<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-md-25">
      <form enctype="multipart/form-data" class="row g-3">
        <!-- Title -->
        <div class="col-12 form-group">
          <label for="spent_title">Dépense (Titre)</label>
          <input
            type="text"
            id="spent_title"
            class="form-control"
            v-model="form.title"
            placeholder="Dépense (Titre)"
          />
        </div>

        <!-- Type -->
        <div class="col-12 form-group">
          <label for="type">Type</label>
          <select
            v-model="form.type"
            id="type"
            class="form-control selectpicker"
            title="Type"
          >
            <option value="">Choisir une option</option>
            <option value="Transport">Transport</option>
            <option value="Carburant">Carburant</option>
            <option value="Salaire">Salaire</option>
            <option value="Consomable">Consomable</option>
            <option value="Électricité/Eau">Électricité/Eau</option>
            <option value="Loyer">Loyer</option>
            <option value="Internet/Téléphone">Internet/Téléphone</option>
          </select>
        </div>

        <!-- Description -->
        <div class="col-12 form-group">
          <label for="spent_description">Description</label>
          <textarea
            id="spent_description"
            class="form-control"
            placeholder="Description"
            v-model="form.description"
          ></textarea>
        </div>

        <!-- Amount -->
        <div class="col-12 form-group">
          <label for="spent_amount">Montant dépensé</label>
          <input
            type="number"
            id="spent_amount"
            class="form-control"
            v-model="form.amount"
            placeholder="Montant dépensé"
          />
        </div>

        <!-- Date -->
        <div class="col-12 form-group">
          <label for="spent_date">Date de dépense</label>
          <input
            type="date"
            id="spent_date"
            class="form-control"
            v-model="form.spent_date"
          />
        </div>

        <!-- Payment mode -->
        <div class="col-12 form-group">
          <label for="mode">Mode de paiement</label>
          <select
            v-model="form.pay_mode"
            id="mode"
            class="form-control selectpicker"
            title="Mode de paiement"
          >
            <option value="">Choisir une option</option>
            <option value="Carte bancaire">Carte bancaire</option>
            <option value="Paiement en espèces (cash)">
              Paiement en espèces (cash)
            </option>
            <option value="Virement bancaire">Virement bancaire</option>
          </select>
        </div>

        <!-- File upload -->
        <div class="col-12 form-group">
          <label for="spent_file">Justificatif (PDF/Images uniquement)</label>
          <input
            type="file"
            id="spent_file"
            class="form-control"
            @change="handleFileUpload"
            accept="image/*,application/pdf"
          />
        </div>

        <!-- Button -->
        <div class="col-12 form-group">
          <button class="btn btn-primary mt-4" type="button" @click="saveSpent">
            Ajouter
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import axios from "axios";
import Swal from "sweetalert2";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const form = ref({
      title: "",
      type: "",
      description: "",
      amount: "",
      spent_date: "",
      pay_mode: "",
      spent_file: null as File | null,
    });

    // Handle file upload
    const handleFileUpload = (event: Event) => {
      const target = event.target as HTMLInputElement;
      if (target.files && target.files.length > 0) {
        form.value.spent_file = target.files[0];
      }
    };

    // Save spent
    const saveSpent = async () => {
      // Basic validation
      if (!form.value.title)
        return showToast("Le titre est obligatoire", "error");
      if (!form.value.type)
        return showToast("Le type est obligatoire", "error");
      if (!form.value.amount)
        return showToast("Le montant est obligatoire", "error");
      if (!form.value.spent_date)
        return showToast("La date de dépense est obligatoire", "error");
      if (!form.value.pay_mode)
        return showToast("Le mode de paiement est obligatoire", "error");

      try {
        const formData = new FormData();
        formData.append("title", form.value.title);
        formData.append("type", form.value.type);
        formData.append("description", form.value.description || "");
        formData.append("amount", form.value.amount.toString());
        formData.append("spent_date", form.value.spent_date);
        formData.append("pay_mode", form.value.pay_mode);

        if (form.value.spent_file) {
          formData.append("spent_file", form.value.spent_file);
        }

        const response = await api.post("/api/auth/spents", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.success) {
          showToast("La dépense a été ajoutée avec succès", "success");
          // Reset form
          form.value = {
            title: "",
            type: "",
            description: "",
            amount: "",
            spent_date: "",
            pay_mode: "",
            spent_file: null,
          };
          (document.getElementById("spent_file") as HTMLInputElement).value =
            "";
        }
      } catch (error: any) {
        console.error(error);
        const message =
          error.response?.data?.message || "Une erreur s'est produite";
        showToast(message, "error");
      }
    };

    return {
      form,
      handleFileUpload,
      saveSpent,
    };
  },
});
</script>
